

















import Vue, { PropType } from "vue";
import TextEditor from "./editor/TextEditor.vue";
import ImageEditor from "./editor/ImageEditor.vue";
import VideoEditor from "./editor/VideoEditor.vue";
import ContentModel from "@/dex-shared/models/ContentModel";

export default Vue.extend({
  components: {
    TextEditor,
    ImageEditor,
    VideoEditor
  },
  props: {
    content: {
      type: Object as PropType<ContentModel>,
      required: true
    },
    trustedContent: {
      type: Boolean,
      default: false
    }
  },
});
